export default {
  USER_SET_STATE: '@user/USER_SET_STATE',
  USER_SETUP_SAVE: '@user/USER_SETUP_SAVE',
};
